import React from 'react';

import { List } from 'antd';

import styled from 'styled-components';

import { getFileTypeIcons } from '@libs/NwUtils';

import useNwBreakPoints from '@hooks/Layout/UseNwBreakPoints';

import EventTypeTag from '@components/EventDetails/EventTypeTag';
import { getEvent } from '@components/EventDrawer/BookingEvent/bookingEventUtils';
import FlexContainer from '@components/Gui/FlexContainer';
import NwIcon from '@components/Gui/NwIcon';

const ListItemMeta = styled(List.Item.Meta)`
    padding: 0;
    cursor: pointer;
    align-items: center;
    &:hover {
        background-color: ${(props) => !props.$disablehover && props.theme.SelectedBackgroundColor};
        .document-image {
            color: ${(props) => !props.$disablehover && props.theme.PrimaryColor};
        }
    }
    .ant-card-grid {
        padding: 24px;
    }
    .doc-hidden {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-size: ${(props) => props.theme.FontSizeSm};
        color: ${(props) => props.theme.DangerColor};
        text-transform: uppercase;
    }
`;

const DocumentItemThumbStyle = styled.div`
    svg {
        /* margin-left: 8px; */
        width: auto;
        height: 2.75rem;
    }
`;

const DocumentContent = styled.div`
    width: calc(100% - 120px);
    min-width: 80px;
    .title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;

const Document = ({ actions, disablehover, document, events, getDescription, onDocumentClick, showTag }) => {
    const event = getEvent(events, document);
    const breakpoints = useNwBreakPoints();
    return (
        <ListItemMeta
            $disablehover={disablehover}
            avatar={
                <DocumentItemThumbStyle onClick={() => onDocumentClick(document)} className="document-image">
                    <NwIcon icon={getFileTypeIcons(document.Extension)} />
                </DocumentItemThumbStyle>
            }
            title={
                <FlexContainer justifyContent="space-between">
                    <DocumentContent onClick={() => onDocumentClick(document)}>
                        {showTag && event && <EventTypeTag event={event} />}
                        <div className="title">{document.Title}</div>
                    </DocumentContent>
                    {actions && breakpoints !== 1 && actions(document)}
                </FlexContainer>
            }
            description={
                <div>
                    {getDescription(document)}
                    {breakpoints === 1 && actions && <FlexContainer mg="12px 0 0">{actions(document)}</FlexContainer>}
                </div>
            }
        />
    );
};

// Document.propTypes = {
//     document: PropTypes.shape({
//         ID: PropTypes.number.isRequired
//     }),
//     handleShowDocumentDrawer: PropTypes.func,
//     getDescription: PropTypes.func.isRequired,
//     actions: PropTypes.func,
//     showTag: PropTypes.bool,
// }

export default Document;
